module.exports = __webpack_public_path__ + "img/co_wrapbg4.1a160927.png";